import React from 'react';
import { MailIcon } from 'lucide-react';
const links = ['Privacy Policy', 'Terms of Service'];
export function SiteFooter() {
  return <footer className="w-full border-t border-line bg-night" data-id="element-202" data-mp="3r8rikunn8i0h">
      <div className="mx-auto max-w-6xl px-4 py-10 text-center sm:px-5 sm:py-12" data-id="element-203" data-mp="3mgrcslkw6uvz">
        <p className="font-display text-xl uppercase tracking-tight text-cream sm:text-2xl" data-id="element-204" data-mp="3hips5w7tinie">
          TeachersKit<span className="text-gold" data-id="element-205" data-mp="3dhe0ll5dvs7k">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm text-cream-muted" data-id="element-206" data-mp="3di5v0sn8vjw9">
          The complete “Print &amp; Go” system for guitar teachers. Because teaching guitar
          shouldn’t cost you every Sunday of the year.
        </p>

        <a href="mailto:support@stockdigital.shop" className="mt-5 inline-flex items-center gap-2 rounded-full border border-line bg-panel px-4 py-2.5 text-sm font-medium text-cream transition-colors duration-150 ease-expo hover:border-gold/50 hover:text-gold" data-id="element-207" data-mp="2yju0arjfml7q">
          <MailIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-208" data-mp="15qva55gw0thu" />
          support@stockdigital.shop
        </a>

        <nav aria-label="Footer" className="mt-6" data-id="element-209" data-mp="1aqhndewpu9qn">
          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2" data-id="element-210" data-mp="1ar9jqry50bhz">
            {links.map(link => <li key={link} data-id="element-211" data-mp="10rsf8dumg3nl">
                <a href="#" className="text-sm text-cream-muted transition-colors duration-150 ease-expo hover:text-gold" data-id="element-212" data-mp="10qz5d40d8y18">
                  {link}
                </a>
              </li>)}
            <li data-id="element-213" data-mp="1tiivz8zaled9">
              <a href="mailto:support@stockdigital.shop" className="text-sm text-cream-muted transition-colors duration-150 ease-expo hover:text-gold" data-id="element-214" data-mp="1erjmzwujont5">
                Contact Us
              </a>
            </li>
          </ul>
        </nav>

        <p className="mt-8 border-t border-line pt-6 text-[10px] font-medium uppercase tracking-[0.14em] text-cream-muted sm:text-xs" data-id="element-215" data-mp="27ee4qlzz992x">
          © 2026 TeachersKit™ — All rights reserved.
        </p>
      </div>
    </footer>;
}